import { Injectable } from "@angular/core";
import { CustomerEndpoint } from "@app/services/customer-registration/customer-endpoint.service";
import { Customer, FileUpload } from "@app/models/customer-registration/CustomerModel";
import { CustomerSearchInfo } from "@app/models/customer-list/CustomerListModel";


@Injectable()
export class CustomerService {

    constructor(private CustomerEndpoint: CustomerEndpoint) { }

    getOTP(customerinfo) {
        return this.CustomerEndpoint.getOTP(customerinfo);
    }

    resendMobileOTP(mobileNumberOTP) {
        return this.CustomerEndpoint.resendMobileOTP(mobileNumberOTP);
    }
    verifyOTP(mobileNumber, otp) {
        return this.CustomerEndpoint.verifyOTP(mobileNumber, otp);
    }
    registerRetailCustomer(customerinfo: Customer) {
        return this.CustomerEndpoint.registerRetailCustomer(customerinfo);
    }
    updateFleetCustomer(customerinfo: Customer) {
        return this.CustomerEndpoint.updateFleetCustomer(customerinfo);
    }
    registerFleetCustomer(customerinfo: Customer) {
        return this.CustomerEndpoint.registerFleetCustomer(customerinfo);
    }
    getCustomerDetails(id: number) {
        return this.CustomerEndpoint.getCustomerDetails(id);
    }
    registerPostImageData(formData: FormData) {
        return this.CustomerEndpoint.registerPostImageData(formData);
    }
    GetCustomerList(customerListModel: CustomerSearchInfo) {
        return this.CustomerEndpoint.GetCustomerList(customerListModel);
    }
    RejectCustomerDetail(customerFileDetails: FileUpload) {
        return this.CustomerEndpoint.RejectCustomerDetail(customerFileDetails);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/customer-registration/customer.service.ts